module.exports = __webpack_public_path__ + "static/contact_other_plane-d0b4964c8b8996695863fd3c22cd8c5a.jpg";